import { createContext, useEffect, useState } from 'react'
import Loader from '../components-legacy/Loader.jsx'
import { createScript } from '../system/util.js'
import { api } from '../system/api.js'

/**
 * Signed-in user and their plan. Null outside the provider — consumers must
 * guard, and several (BotDetail, the test harness) deliberately render without
 * it. Typed explicitly because `createContext(null)` alone infers `Context<null>`,
 * which makes every `.session` read an error.
 *
 * @typedef {{ name?: string, email?: string, internal?: boolean,
 *             subscription?: { plan?: string, slug?: string, sponsor?: string|false,
 *                              canRunBacktest?: boolean } | null }} AppSession
 * @type {import('react').Context<{ session: AppSession | null } | null>}
 */
const AppContext = createContext(null)

const AppProvider = ({ children }) => {
    const [session, setSession] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {

        api('auth').then((res) => {
            if (res) {
                setSession({
                    name: res.name,
                    email: res.email,
                    subscription: res.subscription,
                    internal: res.internal === true,
                })
            }
        }).finally(() => {
            setLoading(false)
        })

    }, [])

    useEffect(() => {

        if (session && !session.internal) {
            createScript("/js/analytics.js")
            createScript("https://cdp.algobuilder.com/algobuilder.min.js")
        }

    }, [session])

    if (loading) {
        return <Loader />
    }

    return (
        <AppContext.Provider value={{ session }}>
            {children}
        </AppContext.Provider>
    )
}

export { AppContext, AppProvider }